import { AnswerType } from '../enums/AnswerType';
import { ddMmYyyyToIsoDate } from '../functions/DateTime'

export const questionValidation = (question: any) => {
    let valid = mandatoryValidation(question);

    if (valid) {
        valid = regexValidation(question);
    }

    if (valid) {
        valid = lengthValidation(question);
    }

    if (valid) {
        if (question.questionSetAnswerType.answerTypeBaseTypeID === AnswerType.DatePicker) {
            valid = dateValidation(question);
            if (valid) {
                valid = dateRangeValidation(question);
            }
        } else {
            valid = rangeValidation(question);
        }
    }

    return valid;
}


export const resetValidation = (questions: any[]) => {
    return questions.map((question) => {
        question.validationFail = false;

        if (question.childInformation != null) {
            question.childInformation.map((childQuestion: any) => {
                childQuestion.validationFail = false;
                return childQuestion;
            });
        }
        return question;
    });
}


export const formValidation = (question: any) => {
    let valid = mandatoryValidation(question);

    if (valid && question.repeatable) {
        valid = repeatableChildValidation(question);
    }

    if (!question.questionSetQuestion.visible || !question.questionSetQuestion.enabled) {
        valid = true;
    }

    if (question.sectionName.toLowerCase() === "property details" && question.index === 0) {
        valid = true;
    }

    if (question.questionSetQuestion.text.toLowerCase().includes("is the building currently fully occupied?") && question.index > 0) {
        valid = question.childInformation.some((x: { index: number; }) => x.index > 0);
    }

    return valid;
}


export const mandatoryValidation = (question: any) => {
    if (question.questionSetQuestion.mandatory && question.questionSetQuestion.visible && question.questionSetQuestion.enabled) {
        if (question.answer !== "" && question.answer !== null && question.answer !== undefined) {
            return true;
        } else {
            return false;
        }
    } else {
        return true;
    }
}


export const regexValidation = (question: any) => {
    if (question.questionSetAnswerType.regex !== "" && question.questionSetAnswerType.regex !== null && question.questionSetAnswerType.regex !== undefined) {
        var questionRegex = new RegExp(question.questionSetAnswerType.regex);
        // ver1  var mobileRegex = /^\s*\(?((\+0?44)?\)?[ \-]?(\(0\))|0)((20[7,8]{1}\)?[ \-]?[1-9]{1}[0-9]{2}[ \-]?[0-9]{4})|([1-8]{1}[0-9]{3}\)?[ \-]?[1-9]{1}[0-9]{2}[ \-]?[0-9]{3}))\s*$/;
        // ver 2 no landline var mobileRegex = /^(?:(?:(?:\+|00)44\s?|0)[7]\d{9}|(?:(?:\+|00)44\s?|0)[7-9]\d{4}\s?\d{5})$/;
        var mobileRegex = /^(?:(?:(?:\+|00)44\s?|0)([1-9]\d{4}\s?\d{6}|[1-9]\d{2}\s?\d{3}\s?\d{4})|(?:(?:\+|00)44\s?|0)[7]\d{9})$/;
        var emailRegex = /^[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]@[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]$/;

        var validation = true;

        if (question.questionSetQuestion.text.toLowerCase().includes("email") || question.questionSetQuestion.text.toLowerCase().includes("number")) {
            if (question.questionSetQuestion.text.toLowerCase().includes("email")) {
                validation = emailRegex.test(question.answer);
            }

            if (question.questionSetQuestion.text.toLowerCase().includes("number")) {
                question.answer = question.answer.replace("+44", "0");

                if (question.answer.length > 1 && !question.answer.startsWith("0")) {
                    question.answer = "0" + question.answer;
                }

                validation = mobileRegex.test(question.answer);
            }
        } else {
            validation = questionRegex.test(question.answer);
        }

        return validation;

    } else {
        return true;
    }
}


export const lengthValidation = (question: any) => {
    if (question.questionSetAnswerType.length !== "" && question.questionSetAnswerType.length !== null && question.questionSetAnswerType.length !== undefined) {
        return question.answer.length <= question.questionSetAnswerType.length;
    } else {
        return true;
    }
}

export const rangeValidation = (question: any) => {
    let withinRange = true;
    if (question.questionSetAnswerType.startRange !== "" && question.questionSetAnswerType.startRange !== null && question.questionSetAnswerType.startRange !== undefined) {
        withinRange = question.answer >= parseInt(question.questionSetAnswerType.startRange)
    }

    if (withinRange && question.questionSetAnswerType.endRange !== "" && question.questionSetAnswerType.endRange !== null && question.questionSetAnswerType.endRange !== undefined) {
        withinRange = question.answer <= parseInt(question.questionSetAnswerType.endRange)
    }

    return withinRange;
}

export const dateValidation = (question: any) => {
    var date = new Date(question.answer);

    var day = parseInt(question.answer.substr(8, 2));
    var month = parseInt(question.answer.substr(5, 2));
    var year = parseInt(question.answer.substr(0, 4));

    if (date instanceof Date && !isNaN(date.valueOf()) && date.getFullYear() === year && date.getMonth() + 1 === month && date.getDate() === day) {
        return true;
    } else {
        return false;
    }
}

export const dateRangeValidation = (question: any) => {
    let withinRange = true;
    if (question.questionSetAnswerType.startRange !== "" && question.questionSetAnswerType.startRange !== null && question.questionSetAnswerType.startRange !== undefined) {
        let startRange = new Date(ddMmYyyyToIsoDate(question.questionSetAnswerType.startRange));
        withinRange = new Date(question.answer) >= startRange;
    }

    if (withinRange && question.questionSetAnswerType.endRange !== "" && question.questionSetAnswerType.endRange !== null && question.questionSetAnswerType.endRange !== undefined) {
        let endRange = new Date(ddMmYyyyToIsoDate(question.questionSetAnswerType.endRange));

        endRange.setDate(endRange.getDate() + 1);

        endRange = new Date(endRange.toDateString());

        withinRange = new Date(question.answer) < endRange
    }

    return withinRange;
}

export const repeatableChildValidation = (question: any) => {
    let valid = true;
    let answerText = question.answerList?.find((x: any) => x.value === question.answer)?.text ?? question.answer;

    if (parseInt(answerText) > 0 && question.childInformation != null) {
        if (question.questionSetAnswerType.answerTypeName === "Boolean") {
            if (question.questionSetQuestion.childQuestionRepeatMinimum > 0) {
                valid = question.childInformation.some((x: { index: number; }) => x.index === question.questionSetQuestion.childQuestionRepeatMinimum);
            } else {
                valid = question.childInformation.some((x: { index: number; }) => x.index === 1);
            }

            if (question.questionSetQuestion.childQuestionRepeatMaximum > 0 && valid) {
                valid = !question.childInformation.some((x: { index: number; }) => x.index === question.questionSetQuestion.childQuestionRepeatMaximum + 1);
            }
        }

        if (question.questionSetAnswerType.answerTypeName === "ListValueID"
            || question.questionSetAnswerType.answerTypeName === "RadioSelect") {

            valid = question.childInformation.some((x: { index: number; }) => x.index === parseInt(answerText));

            if (valid && !answerText.includes("+")) {
                valid = !question.childInformation.some((x: { index: number; }) => x.index === parseInt(answerText) + 1);
            }
        }
    }

    return valid;
}

export const emailValidation = (value: string) => {
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return emailRegex.test(value);
}

export const passwordValidation = (value: string) => {
    return value.length > 5;
}

export const validFutureDate = (day: string, month: string, year: string) => {
    let dateInput = month + "/" + day + "/" + year;
    let dateObj = new Date(dateInput);

    if (dateObj.toString() === "Invalid Date") {
        return false;
    } else {
        if (dateObj < new Date()) {
            return false;
        } else {
            return true;
        }
    }
} 

// Validation if both answers to related questions are set to a fail value 
// i.e.being a limited company but answering 0 to both number of directors that carry out manual or clerical work only questions where at least one of those questions must have an answer of more than 0 to pass
export const relatedQuestionsValidation = (questions: any, questionID1: number, questionID2: number, allAnsweredFailValue: string, validationMessageOverride: string) => {
    var answer1 = allAnsweredFailValue;
    var answer2 = allAnsweredFailValue;
    var formValid = true;

    questions.forEach((question: any) => {
        if (question.questionSetQuestion.questionID === questionID1) {
            answer1 = question.answer;
        }

        if (question.questionSetQuestion.questionID === questionID2) {
            answer2 = question.answer;
        }
    });

    if (answer1 === allAnsweredFailValue && answer2 === allAnsweredFailValue) {
        formValid = false;
        var updatedRelatedQuestionsValidationQuestions = questions.map((question: any) => {
            if (question.questionSetQuestion.questionID === questionID1 || question.questionSetQuestion.questionID === questionID2) {
                question.validationFail = true;
                question.validationMessage = validationMessageOverride;
            }

            return question;
        });
    }

    var returnObject = {
        questions: updatedRelatedQuestionsValidationQuestions,
        valid: formValid
    }

    return returnObject;
}

export const resetRelatedQuestionsValidation = (questions: any, questionID1: number, questionID2: number) => {
    var updatedRelatedQuestionsValidationQuestions = questions;
    updatedRelatedQuestionsValidationQuestions = questions.map((question: any) => {
        if (question.questionSetQuestion.questionID === questionID1 || question.questionSetQuestion.questionID === questionID2) {
            question.validationFail = false;
        }

        return question;
    });

    return updatedRelatedQuestionsValidationQuestions;
}

export const coverAddedRequiredValiation = (questions: any, sectionName: string) => {
    let valid = true;
    var coverAdded = questions.filter((x: { sectionName: string; answer: string; parentQuestionID: null; }) => x.sectionName === sectionName && x.answer === "1" && x.parentQuestionID === null);
    valid = coverAdded.length > 0;

    if (coverAdded.length === 0) {
        var updatedRelatedQuestionsValidationQuestions = questions.map((question: any) => {
            if (question.sectionName === sectionName && question.answer === "0" && question.parentQuestionID === null) {
                question.validationFail = true;
                question.validationMessage = "You must include at least one cover";
            }

            return question;
        });
    }

    var returnObject = {
        questions: updatedRelatedQuestionsValidationQuestions,
        valid: valid
    }

    return returnObject;
}

export const resetCoverAddedRequiredValiation = (questions: any, sectionName: string) => {
    var updatedRelatedQuestionsValidationQuestions = questions.map((question: any) => {
        if (question.sectionName === sectionName && question.parentQuestionID === null) {
            question.validationFail = false;
        }

        return question;
    });

    return updatedRelatedQuestionsValidationQuestions;
}

export const MultipleSectionsCoverAddedRequiredValiation = (questions: any, sectionNames: string[]) => {
    let valid = true;
    var coverAdded = questions.filter((x: { sectionName: string; answer: string; parentQuestionID: null; questionSetQuestion: { enabled: any; visible: any }; }) => sectionNames.includes(x.sectionName) && x.answer !== "0" && x.parentQuestionID === null && x.questionSetQuestion.enabled && x.questionSetQuestion.visible);
    valid = coverAdded.length > 0;

    console.log(coverAdded);

    if (coverAdded.length === 0) {
        var updatedRelatedQuestionsValidationQuestions = questions.map((question: any) => {
            if (sectionNames.includes(question.sectionName) && question.answer === "0" && question.parentQuestionID === null && question.questionSetQuestion.enabled && question.questionSetQuestion.visible) {
                question.validationFail = true;
                question.validationMessage = "You must include at least one cover";
            }

            return question;
        });
    }

    var returnObject = {
        questions: updatedRelatedQuestionsValidationQuestions,
        valid: valid
    }

    return returnObject;
}

export const resetMultipleSectionsCoverAddedRequiredValiation = (questions: any, sectionNames: string[]) => {
    var updatedRelatedQuestionsValidationQuestions = questions.map((question: any) => {
        if (sectionNames.includes(question.sectionName) && question.parentQuestionID === null) {
            question.validationFail = false;
        }

        return question;
    });

    return updatedRelatedQuestionsValidationQuestions;
}